import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, QrCode } from "lucide-react";

// Livret souvenir : chaque voix enregistrée avec son code QR pour la réécouter.
export default function VoiceBookletButton({ url, name, testId = "voice-booklet-button", className = "" }) {
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const { data } = await api.get(url, { params: { origin: window.location.origin }, responseType: "blob" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(data);
      a.download = `livret-des-voix-${name}.pdf`;
      a.click();
      URL.revokeObjectURL(a.href);
    } catch { toast.error("Livret indisponible pour le moment."); }
    finally { setBusy(false); }
  };
  return (
    <Button variant="outline" onClick={download} disabled={busy} className={`rounded-full ${className}`} data-testid={testId}>
      {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <QrCode className="w-4 h-4 mr-2" />} Livret souvenir des voix
    </Button>
  );
}
